import { ValueProvider } from '@angular/cli';


const RequestUri = {
    process: {
        datum: {
            create: '/process/datum',
            edit: '/process/datum',
            list: '/process/datum',
            detail: '/process/datum/${id}'
        },
        module: {
            create: '/process/module',
            list: '/process/module',
            open: '/process/module/$1/open',
            detail: '/process/module/$1',
            edit: '/process/module/$1',
            abandon: '/process/module/$1/abandon'
        },
        main: {
            create: '/process',
            list: '/process',
            open: '/process/$1/open',
            detail: '/process/$1',
            edit: '/process/$1',
            abandon: '/process/$1/abandon'
        }
    },
    project: {
        clue: {
            list: '/compact/apply',
            detail: '/compact/apply/detail',
            update: '/compact/apply',
            sign: '/compact/apply/sign'
        },
        compact: {
            list: '/compact',
            create: '/compact',
            update: '/compact',
            detail: '/compact/detail',

            datumComplete: '/compact/datum',
            datumCompleteList: '/compact/datum',
            moduleDetail: '/compact/module',
            moduleComplete: '/compact/module/complete',
            moduleReject: '/compact/module/reject',
            modulePass: '/compact/module/pass',
            moduleLose: '/compact/module/lose',

            attachAdd: '/compact/module/attach',
            attachDel: '/compact/module/attach'
        }
    },
    user: {
        staff: {
            list: '/account'
        },
        account: {
            create: '/account',
            update: '/account',
            list: '/account',
            enable: '/account/set',
            detail: '/account'
        },
        login: '/login/in',
        logout: '/login/out',
        password: '/password',
        passwordCode: '/password/code'
    },
    my: {
        wait: '/my/todo',
        check: '/my/check'
    },
    statistics: {
        compact: '/statistics/compact',
        operator: '/statistics/operator'
    }

};

export const RequestProvider: ValueProvider = {provide: 'RequestJson', useValue: RequestUri};





// WEBPACK FOOTER //
// /Users/liyankai/Documents/github/seiya_web.git/src/app/lib/provider/request.ts